import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService, AuthenticationService } from '../../services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-medical-consultation',
  templateUrl: './medical-consultation.component.html',
  styleUrls: ['./medical-consultation.component.scss']
})

export class MedicalConsultationComponent implements OnInit {
  isChecked: boolean;
  isLoggedIn: Observable<boolean>;

  constructor( 
    private dataService: DataService,
    public router: Router,
    private authenticationService: AuthenticationService
   ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.authenticationService.isLoggedIn();
    this.dataService.getLocalConsultationStatus().subscribe(status => 
      this.isChecked = status
    );
  }

  addConsultationToCart() {
    this.isChecked = !this.isChecked; 
    this.dataService.saveLocalAddConsultationStatus(this.isChecked);
  }

  goToCart() {
    this.router.navigateByUrl('cart');
  }
}
